import isGroupItem from './isGroupItem';
import { ClientItem } from 'owa-mail-store';
import { isFolderOfTreeType } from 'owa-folders';
import { PRIMARY_FOLDERS_TREE_TYPE, ARCHIVE_FOLDERS_TREE_TYPE } from 'owa-folders-constants';

export default function shouldAddAssignPolicyMenuItem(folderId: string, item: ClientItem): boolean {
    // TODO 133154: Enable Item level retention policies when UpdateItem substrate API is fixed for applying policies in groups
    if (isGroupItem(item)) {
        return false;
    }

    return (
        isFolderOfTreeType(folderId, PRIMARY_FOLDERS_TREE_TYPE) ||
        isFolderOfTreeType(folderId, ARCHIVE_FOLDERS_TREE_TYPE) ||
        isFolderOfTreeType(folderId, 'favorites')
    );
}
